import setRatingCss from "./setRatingCss";
import { Apptus } from "../../apptus/apptus";

var titlesForRating = new Array('Kass', 'Inte så värst bra', 'Helt ok', 'På min topplista', 'Världsklass');
export default function initStarRating() {
  $(".product-col ul.star-rating li").on("mouseover", function () {
    var ul = $(this).parent();
    var newRating = $(this).index() + 1;
    setRatingCss(ul, newRating);
  });

  $(".product-col ul.star-rating li").on("mouseout", function () {
    var ul = $(this).parent();
    var rating = $(ul).data("rating");
    setRatingCss(ul, rating);
  });
  $('.star-rating').each(function () {
    $('li', this).each(function () {
      $("span", this).attr('title', titlesForRating[$(this).index()]);
    });
  });

  $(".product-col .star-rating li").not(".big-star-rating .star-rating li").off("click touchend").on('click touchend', function (e) {
    e.preventDefault();

    var newRating = $(this).index() + 1;
    var $container = $(this).parent();
    var postId = $container.data("idf");

    var cookieNow = $.cookie('grade');

    if (cookieNow == null) {
      cookieNow = newRating;
    }

    $.cookie('grade', cookieNow, { expires: 365, path: '/' });

    if ($.cookie('grade') && $.cookie('grade').indexOf(postId) >= 0) {
      alert("Du har redan betygsatt den här produkten");
    } else {
      $.ajax({
        url: "/api/product/SetRating",
        contentType: "application/json",
        method: "POST",
        data: JSON.stringify({ identifier: postId, rating: newRating }),
        async: true,
        success: function (obj) {
          if (obj.Success) {
            $container.data("rating", newRating); //set the rating attribute
            var text = $("#ratingText").val();
            $("#ratingMessage").text(text);
            setRatingCss($container, newRating); //update the display
            $(this).closest('.star-rating').clone().addClass('animate').appendTo('.product-col.rating');
          } else if (obj.Message.length) {
            alert(obj.Message);
          }
          Apptus.NotifyVote(postId, newRating);
        }
      });
    }
  });

  $(".big-star-rating .star-rating li").off("click").on('click', function () {
    var newRating = $(this).index() + 1;
    var $container = $(this).parent();
    $container.data("rating", newRating);
    setRatingCss($container, newRating);
  });
}